import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function SocialCallback() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const error = params.get('error');

        if (token) {
            // Save token and let useAuth fetch the user profile in its useEffect
            localStorage.setItem('cr_token', token);
            // We don't have user info yet, but useAuth will fetch it
            // because it has a useEffect listening for cr_token
            navigate('/home');
        } else {
            console.error('Social login failed:', error);
            navigate('/login?error=' + (error || 'social_auth_failed'));
        }
    }, [location, navigate]);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: '#0a0f14',
            color: '#8a6d3b',
            fontFamily: 'Inter, sans-serif'
        }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '24px', marginBottom: '16px' }}>Authenticating...</div>
                <div style={{ fontSize: '14px', opacity: 0.7 }}>Please wait while we finalize your login</div>
            </div>
        </div>
    );
}

export default SocialCallback;
